module.exports = __webpack_public_path__ + "static/media/close-popup-gallery.ec2a1c09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/close-popup-gallery.svg
// module id = 1453
// module chunks = 0